angular.module('dnecom')
    .controller('ZonesModalController', ["$scope", "$uibModalInstance", "zone", "$timeout", "isLegacy", function ($scope, $uibModalInstance, zone, $timeout, isLegacy) {
        $scope.isLegacy = angular.copy(isLegacy);
        const ShippingCostTypeEnum = {
            TYPE_FLAT_FEE: 1,
            TYPE_TOTAL_COSTS: 2,
            TYPE_CUSTOM: 3,
            TYPE_CUSTOM_PER_PRODUCT: 4,
        };
        $scope.ShippingCostTypeEnum = ShippingCostTypeEnum;

        const DeliveryServicesEnum = {
            STANDARD: 'standard',
            EXPEDITED: 'expedited',
            PREMIUM: 'premium',
            PICKUP: 'local pickup',
        };
        $scope.DeliveryServicesEnum = DeliveryServicesEnum;

        /**
         * Every shipping costy type in ShippingCostTypeEnum
         * requires specific options set
         */
        const shippingCostTypeOptionTemplates = {
            [ShippingCostTypeEnum.TYPE_FLAT_FEE]: {
                service: DeliveryServicesEnum.STANDARD,
                minDays: '',
                maxDays: '',
                price: '',
            }
        };

        $scope.zone = angular.copy(zone || {});
        $scope.zone.shippingCostType = $scope.zone.shippingCostType || ShippingCostTypeEnum.TYPE_FLAT_FEE;
        $scope.zone.shippingCost = $scope.zone.shippingCost || [];

        if ($scope.zone.shippingCostType === ShippingCostTypeEnum.TYPE_TOTAL_COSTS
            && $scope.zone.shippingCost.val
        ) {
            $scope.zone.shippingCost = [$scope.zone.shippingCost.val];
        }

        $scope.addShippingOption = addShippingOption;
        $scope.updateShippingOption = updateShippingOption;
        $scope.canAddAnotherOption = canAddAnotherOption;
        $scope.getDaysVerbose = getDaysVerbose;
        $scope.fixMinDays = fixMinDays;
        $scope.fixMaxDays = fixMaxDays;
        $scope.fixShippingCosts = fixShippingCosts;
        $scope.fixCustomShippingCosts = fixCustomShippingCosts;
        $scope.deleteShippingOption = deleteShippingOption;
        $scope.addPricingRange = addPricingRange;
        $scope.deletePricingRange = deletePricingRange;
        $scope.fixTo = fixTo;
        $scope.fixFrom = fixFrom;
        $scope.validatePrices = validatePrices;
        $scope.hasPricingError = hasPricingError;
        if ($scope.zone.shippingCost !== null && !$scope.zone.shippingCost.length && !$scope.zone.shippingCost.hasOwnProperty('val') && $scope.zone.shippingCostType == 1) {
            addShippingOption();
        }

        $scope.invalidPrices = {};
        $scope.zone.countries = $scope.zone.countries || [];
        $scope.inputInvalid = false;
        $scope.step = 1;
        $scope.allSteps = 3;

        $scope.countries = TemplateData.value('countries');
        $scope.states = TemplateData.value('states');

        $scope.originalCountries = angular.copy($scope.countries);
        $scope.originalStates = angular.copy($scope.states);

        $scope.selectedCountry = null;

        $scope.wizardForm = {};

        function addShippingOption(event) {
            if (event) {
                event.preventDefault();
            }
            const configuredServices = $scope.zone.shippingCost.map(o => o.service);
            const serviceOptions = _.cloneDeep(shippingCostTypeOptionTemplates[$scope.zone.shippingCostType]);
            const unusedServices = _.difference(Object.values(DeliveryServicesEnum), configuredServices);
            if (unusedServices.length) {
                serviceOptions.service = unusedServices.shift();

            } else {
                serviceOptions.service = 'local pickup';
            }
            $scope.zone.shippingCost.push(serviceOptions);
        }

        function updateShippingOption(index, deliveryService, prevValue) {
            if (deliveryService === 'local pickup') {
                return ;
            }
            // find the another option with same pre-configured service
            const duplicate = $scope.zone.shippingCost.find((el, idx) =>
                idx !== index && el.service === deliveryService
            );

            if (duplicate && prevValue) {
                duplicate.service = prevValue;
            }
        }

        function canAddAnotherOption() {
            const configuredServices = $scope.zone.shippingCost.map(o => o.service);
            const unusedServices = Object.values(DeliveryServicesEnum).filter(s => !configuredServices.includes(s));
            return !!unusedServices.length;
        }

        function getDaysVerbose(minDays, maxDays) {
            let expr = '';
            if (minDays) {
                if (maxDays) {
                    expr = `${minDays} - ${maxDays}`;
                } else {
                    expr = minDays;
                }
            } else {
                if (maxDays) {
                    expr = `up to ${maxDays}`;
                }
            }

            if (expr) {
                const daysWord = (minDays > 1 || maxDays > 1) ? 'days' : 'day';

                expr = `${expr} ${daysWord}`;
            }

            return expr;
        }

        function fixMinDays(idx) {
            let minDays = $scope.zone.shippingCost[idx].minDays;
            let maxDays = $scope.zone.shippingCost[idx].maxDays;
            maxDays = maxDays || 1;

            if (maxDays <= minDays) {
                if (maxDays > 1) {
                    minDays = maxDays - 1;
                } else {
                    minDays = 1;
                    maxDays = 2;
                }
            }

            $scope.zone.shippingCost[idx].minDays = minDays;
            $scope.zone.shippingCost[idx].maxDays = maxDays;
        }

        function fixMaxDays(idx) {
            let minDays = $scope.zone.shippingCost[idx].minDays;
            minDays = minDays || 1;

            let maxDays = $scope.zone.shippingCost[idx].maxDays;

            if (maxDays <= minDays) {
                maxDays = minDays + 1;
            }

            $scope.zone.shippingCost[idx].minDays = minDays;
            $scope.zone.shippingCost[idx].maxDays = maxDays;
        }

        function fixShippingCosts(idx) {
            if (!$scope.zone.shippingCost[idx].price) {
                $scope.zone.shippingCost[idx].price = 0;
            }
        }

        function deleteShippingOption(idx) {
            $scope.zone.shippingCost = $scope.zone.shippingCost.filter((o, i) => i !== idx);
        }

        function addPricingRange(event, idx) {
            event.preventDefault();
            const pricing = $scope.zone.shippingCost[idx].pricing;
            let from = 0;
            let to = 1;

            if (pricing.length) {
                const lastRange = pricing[pricing.length - 1];
                from = lastRange.to + 0.01;
                from = Math.round((from + Number.EPSILON) * 100) / 100;
                to = lastRange.to + 1;
            }

            $scope.zone.shippingCost[idx].pricing.push({
                from,
                to,
                price: 0,
            });
        }

        function deletePricingRange(shippingOptionKey, pricingKey) {
            $scope.zone.shippingCost[shippingOptionKey].pricing.splice(pricingKey, 1);
        }

        function fixTo(shippingOptionKey, pricingKey) {
            let p = $scope.zone.shippingCost[shippingOptionKey].pricing[pricingKey];
            if (p.to <= p.from) {
                p.to = p.from + 1;
                p.to = Math.round((p.to + Number.EPSILON) * 100) / 100;
                $scope.zone.shippingCost[shippingOptionKey].pricing[pricingKey].to = p.to;
            }
        }

        function fixFrom(shippingOptionKey, pricingKey) {
            let p = $scope.zone.shippingCost[shippingOptionKey].pricing[pricingKey];
            if (p.to <= p.from) {
                if (p.to <= 1) {
                    p.from = 0;
                } else {
                    p.from = p.to - 0.99;
                    p.from = Math.round((p.from + Number.EPSILON) * 100) / 100;
                }

                $scope.zone.shippingCost[shippingOptionKey].pricing[pricingKey].from = from;
            }
        }

        function validatePrices(shippingOptionKey) {
            $scope.invalidPrices = {};

            $scope.zone.shippingCost[shippingOptionKey].pricing.forEach((px, ix) => {
                $scope.zone.shippingCost[shippingOptionKey].pricing.forEach((p, i) => {
                    if ((p.from >= px.from && p.from <= px.to ||
                        p.to >= px.from && p.to <= px.to
                    ) && ix !== i) {
                        if (!$scope.invalidPrices[shippingOptionKey]) {
                            $scope.invalidPrices[shippingOptionKey] = [];
                        }
                        if (!$scope.invalidPrices[shippingOptionKey].includes(ix)) {
                            $scope.invalidPrices[shippingOptionKey].push(ix);
                        }
                    }
                });
            });
        }

        function hasPricingError(shippingOptionKey, pricingKey) {
            return $scope.invalidPrices[shippingOptionKey] && $scope.invalidPrices[shippingOptionKey].includes(pricingKey);
        }

        function fixCustomShippingCosts(shippingOptionKey, pricingKey) {
            $scope.zone.shippingCost[shippingOptionKey].pricing[pricingKey].price =
                $scope.zone.shippingCost[shippingOptionKey].pricing[pricingKey].price || 0;
        }

        $scope.countrySelectorOptions = {
            dropdownAutoWidth: true,
            width: 'auto',
            templateResult: function (item, container) {
                if ($scope.isAdded(item.id)) {
                    $(container).addClass('selected');
                }

                return item.text;
            },
            escapeMarkup: function (text) {
                return text;
            }
        };

        $scope.stateSelectorOptions = {
            dropdownAutoWidth: true,
            width: 'auto',
            templateResult: function (item, container) {
                if ($scope.isAdded($scope.selectedCountry, item.id)) {
                    $(container).addClass('selected');
                }

                return item.text;
            },
            escapeMarkup: function (text) {
                return text;
            }
        };

        var getCountryName = function (country) {
            var name = $scope.originalCountries[country.code];

            if (country.states && country.states.length) {
                name += ' (' + country.states.length + ')';
            }

            return name;
        };

        $scope.zone.countries.forEach(function (country) {
            country.name = getCountryName(country);
        });

        $scope.watchCountries = function (items, oldItems) {
            if (items === oldItems) {
                return;
            }

            $scope.wizardForm.$setValidity('countries', angular.isArray(items) && items.length > 0);
        };

        $scope.$watch('zone.countries', $scope.watchCountries, true);

        $scope.prev = function () {
            if ($scope.step > 1) {
                $scope.step--;
            }
        };

        $scope.next = function () {
            $scope.step++;
            $('.wizard-fixed .modal-body').scrollTop(0);
        };

        $scope.getCountryByCode = function (code) {
            if (code && $scope.countries[code]) {
                return $scope.countries[code];
            }

            return null;
        };

        $scope.getStateByCode = function (countryCode, stateCode) {
            if ($scope.states[countryCode] && $scope.states[countryCode][stateCode]) {
                return $scope.states[countryCode][stateCode];
            }

            return null;
        };

        $scope.hasStates = function (countryCode) {
            return $scope.states.hasOwnProperty(countryCode);
        };

        $scope.hasSelectedStates = function (countryCode) {
            var result = false;

            $scope.zone.countries.forEach(function (country) {
                if (country.code == countryCode) {
                    result = country.states.length > 0;
                }
            });

            return result;
        };

        $scope.selectCurrentCountry = function () {
            $scope.addCountry($scope.selectedCountry, null);

            if (!$scope.hasStates($scope.selectedCountry)) {
                $scope.selectedCountry = null;
            }

            $scope.selectedState = null;
        };

        $scope.selectCurrentState = function () {
            $scope.addCountry($scope.selectedCountry, $scope.selectedState);

            if ($scope.selectedState == 'all') {
                $scope.selectedCountry = null;

                // for some reason selector value doesn't clear automatically there, so we fix it by triggering ng-change event
                $timeout(function () {
                    angular.element($('[ng-model="selectedCountry"]')[0]).val('').change();
                });
            }

            $scope.selectedState = null;
        };

        $scope.addAllCountries = function () {
            $scope.zone.countries.forEach(function (country) {
                $scope.removeCountry(country.code);
            });

            Object.keys($scope.countries).forEach(function (code) {
                if (!code) {
                    return;
                }

                var name = $scope.countries[code];

                var zoneCountry = {
                    name: name,
                    code: code,
                    states: []
                };

                if ($scope.states[code]) {
                    Object.keys($scope.states[code]).forEach(function (stateCode) {
                        zoneCountry.states.push({
                            name: $scope.states[code][stateCode],
                            code: stateCode
                        });
                    });
                }

                $scope.zone.countries.push(zoneCountry);
            });
        };

        $scope.addAllStates = function (countryCode) {
            if (!$scope.states[countryCode]) {
                return;
            }

            $scope.removeCountry(countryCode);

            var zoneCountry = {
                name: $scope.countries[countryCode],
                code: countryCode,
                states: []
            };

            Object.keys($scope.states[countryCode]).forEach(function (stateCode) {
                zoneCountry.states.push({
                    name: $scope.states[countryCode][stateCode],
                    code: stateCode
                });
            });

            zoneCountry.name = getCountryName(zoneCountry);

            $scope.zone.countries.push(zoneCountry);
        };

        $scope.addCountry = function (countryCode, stateCode) {
            if (countryCode == 'all') {
                $scope.addAllCountries();
                return;
            }

            var country = $scope.getCountryByCode(countryCode);
            var state = $scope.getStateByCode(countryCode, stateCode);

            if ($scope.hasStates(countryCode) && stateCode == 'all') {
                $scope.addAllStates(countryCode);
                return;
            }

            if (country && (!$scope.hasStates(countryCode) || stateCode)) {
                var existingCountry = {
                    code: countryCode,
                    name: country,
                    states: []
                };

                if (!$scope.isAdded(countryCode)) {
                    $scope.zone.countries.push(existingCountry);
                } else {
                    $scope.zone.countries.forEach(function (zoneCountry) {
                        if (zoneCountry.code == countryCode) {
                            existingCountry = zoneCountry;
                        }
                    });
                }

                if (state && !$scope.isAdded(countryCode, stateCode)) {
                    existingCountry.states.push({
                        code: stateCode,
                        name: state
                    });

                    existingCountry.name = getCountryName(existingCountry);
                }
            }
        };

        $scope.isAdded = function (countryCode, stateCode) {
            if (!stateCode) {
                for (var index in $scope.zone.countries) {
                    var country = $scope.zone.countries[index];

                    if (country.code == countryCode) {
                        return true;
                    }
                }

                return false;
            }

            for (var index in $scope.zone.countries) {
                var country = $scope.zone.countries[index];

                if (country.code == countryCode) {
                    for (var stateIndex in country.states) {
                        var state = country.states[stateIndex];

                        if (state.code == stateCode) {
                            return true;
                        }
                    }
                }
            }

            return false;
        };

        $scope.showSelectedStates = function (countryCode) {
            if ($scope.hasStates(countryCode)) {
                $scope.selectedCountry = countryCode;
            }
        };

        $scope.getSelectedCountryIndex = function () {
            var out = -1;

            $scope.zone.countries.forEach(function (country, index) {
                if (country.code == $scope.selectedCountry) {
                    out = index;
                }
            });

            return out;
        };

        $scope.removeCountry = function (countryCode) {
            $scope.zone.countries.forEach(function (country, index) {
                if (country.code == countryCode) {
                    $scope.zone.countries.splice(index, 1);

                    $scope.countries[country.code] = $scope.originalCountries[country.code];
                }
            });
        };

        $scope.removeState = function (countryCode, stateCode) {
            $scope.zone.countries.forEach(function (country, countryIndex) {
                if (country.code != countryCode) {
                    return;
                }

                country.states.forEach(function (state, stateIndex) {
                    if (state.code == stateCode) {
                        country.states.splice(stateIndex, 1);
                        $scope.states[country.code][state.code] = state.name;
                    }
                });

                if (country.states.length == 0) {
                    $scope.zone.countries.splice(countryIndex, 1);
                    $scope.countries[country.code] = $scope.originalCountries[country.code];
                } else {
                    country.name = getCountryName(country);
                }
            });
        };

        $scope.shippingCostTypeChanged = function () {
            $scope.zone.shippingCost = [];
            if ($scope.zone.shippingCostType == 1) {
                addShippingOption();
            }
        };

        $scope.validateForm = function (form) {
            if (form.$invalid || form.$pending) {
                form.$setTouched();
                $scope.watchCountries($scope.zone.countries);

                return false;
            }

            return true;
        };

        $scope.newRange = function () {
            var from = 0;
            var to = 1;

            if ($scope.zone.shippingCost.length > 0) {
                from = $scope.zone.shippingCost[$scope.zone.shippingCost.length - 1].to + 0.01;
                from = Math.round(from * 100) / 100;
                to = Math.round((from + 0.99) * 100) / 100;
            }

            $scope.zone.shippingCost.push({
                from: from,
                to: to,
                price: 0
            });
        };

        $scope.validateShippingCost = function () {
            let hasError = false;
            if ($scope.zone.shippingCostType === 1 && !$scope.isLegacy) {
                $scope.zone.shippingCost.forEach(function (item) {
                  if (item.maxDays < item.minDays || item.price === null) {
                      hasError = true;
                  }
                })
            }

            return hasError;
        };

        $scope.removeRange = function (index) {
            $scope.zone.shippingCost.splice(index, 1);
        };

        $scope.save = function (form) {
            if (!$scope.validateForm(form) || _.values($scope.invalidPrices).length || $scope.validateShippingCost()) {
                return;
            }

            $uibModalInstance.close($scope.zone);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]);
